import { Component, OnInit } from '@angular/core';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { WrkSessAssist } from 'src/app/shared/models/WrkSessAssist';
import { Form0ChurchAdress } from 'src/app/shared/models/Form0ChurchAdress';
import { WSSessDate } from 'src/app/shared/models/WSSessDate';
import { WsSessionDateKey } from 'src/app/shared/models/WSSessDate';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';

@Component({
  selector: 'app-workshop-session',
  templateUrl: './workshop-session.component.html',
  styleUrls: ['./workshop-session.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class WorkshopSessionComponent implements OnInit {

//Elementos de traducción inicio.
lstRespTranslate: TranslateRelLabelVO[];
lbl_church: string="churchs_";
lbl_service: string="service_";
lbl_schedule: string="schedule_";
lbl_back: string="back_";
lbl_sessions:string="sessions_";
lbl_session:String="session_";
lbl_description:string="description_";
lbl_date:string="date_";
lbl_attendance:string="attendance_";
lbl_search:String="search_";
lbl_place_where_provide:string="place_where_provide_";
 //Elementos de traducción fin
  //Elementos de seguridad inicio
  token: string;
  security: SecurityDocument;
//Elementos de seguridad fin

  wrksId:string;
  listSessions:WrkSessAssist[];
  selectedSession:WrkSessAssist;
  form0Detail: Form0ChurchAdress;

  value: Date;
  clonedSession: { [s: string]: WrkSessAssist; } = {};

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) { 
      this.route.queryParams.subscribe(params => {
        let wrksIdParam = params['wrksId'];
        this.token      = params['token'];

        if(wrksIdParam){
          this.wrksId = wrksIdParam
          
          this.getSecurity();
        }else{
          this.messageService.add({severity:'warn', summary: 'Busqueda Servicio', detail: 'No hay Servicio que buscar', life: 3000});
        }
       
      });

    }

  ngOnInit(): void {
    
  }


  loadSessionByServices(){
    this.apiService.getSessionByServices(this.wrksId, this.security.language).then(
      participants => {
        this.listSessions = participants;
    });

    this.apiService.getDetailForm0({wrksId:this.wrksId}).then(
      detail => {
        this.form0Detail = detail;
    });
  }

  redirectDetail(session: WrkSessAssist){
    const objToSend = {session:session, service:this.form0Detail,token:this.token}
    let navigationExtras: NavigationExtras = {
      state : JSON.parse(JSON.stringify(objToSend))
    }
    this.router.navigate(['secretary/sessionWrksAssist'],navigationExtras);
  }

  onRowEditInit(session: WrkSessAssist) {
    this.clonedSession[session.sessNum] = {...session};
  }

  onRowEditSave(session: WrkSessAssist, index: number) {
  
    if(session.sessDate && this.validateDateCorrect(session.sessDate, index)){
      delete this.clonedSession[session.sessNum];

        let key:WsSessionDateKey = {
          wrksId:session.wrksId,
          sessNum: session.sessNum
        }
        let sessDate:WSSessDate = { id:key, sessDate: session.sessDate } 

        this.apiService.registerAssistanceDate(sessDate).then(
          sessDataupdate => {
            this.messageService.add({severity:'success', summary: 'Actuaización de Fecha', detail:'Fecha se actualizo correctamente'});
            
            this.loadSessionByServices();
        }).catch(error => {
          this.value = null;
          session.sessDate = "";
          console.error(error);
          this.messageService.add({severity:'error', summary: 'Actuaización de Fecha', detail: error, life: 3000});
        });
    }else{
      this.messageService.add({severity:'error', summary: 'Actuaización de Fecha', detail: "Las fechas deben ser en órden ascendente", life: 3000});
      this.value = null;
      session.sessDate = "";
    }
  }

  onRowEditCancel(session: WrkSessAssist, index: number) {
    delete this.clonedSession[session.sessNum];
  }

  onSelectDate(session: WrkSessAssist, index: number){
    session.sessDate = this.tovpilUtils.dateToTovpilDate(this.value);
    this.onRowEditSave(session, index);
  }

  validateDateCorrect(date:string, index:number) : boolean{
    let valid:boolean = false;
    let dateTimeCurr:Date = this.tovpilUtils.convertStringToDate(date);

    if (index == 0 && this.listSessions.length == 1) {
      valid = true;
    }else if (index == 0 && typeof  this.listSessions[index + 1] != 'undefined' && !this.tovpilUtils.isNonEmptyString( this.listSessions[index + 1].sessDate)) {
      valid = true;
    }else if(index == 0 && typeof  this.listSessions[index + 1] != 'undefined' && this.tovpilUtils.isNonEmptyString( this.listSessions[index + 1].sessDate)){
      let dateTimeNext:Date = this.tovpilUtils.convertStringToDate(this.listSessions[index + 1].sessDate);
      if (dateTimeCurr <dateTimeNext) {
        valid = true;
      }
    }else if (index >= 1 &&   index < this.listSessions.length-1 && this.tovpilUtils.isNonEmptyString(this.listSessions[index - 1].sessDate) && this.tovpilUtils.isNonEmptyString(this.listSessions[index + 1].sessDate)){
          let dateTimeNext:Date = this.tovpilUtils.convertStringToDate(this.listSessions[index + 1].sessDate);
          let dateTimeBefore:Date = this.tovpilUtils.convertStringToDate(this.listSessions[index - 1].sessDate);
          if (dateTimeCurr < dateTimeNext && dateTimeCurr >dateTimeBefore) {
            valid = true;
          }
    }else if (index >= 1 && index <= this.listSessions.length-1) {
      let dateTimeBefore:Date = this.tovpilUtils.convertStringToDate(this.listSessions[index - 1].sessDate);
      if (dateTimeCurr > dateTimeBefore) {
        valid = true;
      }
    }
    return valid;
  }


  redirectParent(){
    let params = {};
    if(this.form0Detail){
      params["wrksId"] =  this.form0Detail.wrksId; 
      params["token"] =  this.token; 
    }
    this.router.navigate(['secretary/participants'],{ queryParams: params });
  }
  getSecurity(){
    this.apiService.findSecurityById(
      {  
        "id":this.token
       }
      ).then(
      data => {
        this.security = data;           
        this.getTranslatedLabels();
        this.loadSessionByServices();
    });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstCat: CategoryLan[];
  
    this.apiService.listByLanguageMultFields(
      {
        'language': this.security.language,
        'region': this.security.region,
        'lstLabels': [this.lbl_church,this.lbl_back,this.lbl_service,this.lbl_schedule,
          this.lbl_sessions,this.lbl_description,this.lbl_date,this.lbl_attendance,
          this.lbl_search,this.lbl_session,this.lbl_place_where_provide]
      }
    ).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
       
        this.lbl_church=map.get(this.lbl_church);
        this.lbl_back=map.get(this.lbl_back);
        this.lbl_service=map.get(this.lbl_service);
        this.lbl_schedule=map.get(this.lbl_schedule);
        this.lbl_sessions=map.get(this.lbl_sessions);
        this.lbl_session=map.get(this.lbl_session);
        this.lbl_description=map.get(this.lbl_description);
        this.lbl_date=map.get(this.lbl_date);
        this.lbl_attendance=map.get(this.lbl_attendance);
        this.lbl_search=map.get(this.lbl_search);
        this.lbl_place_where_provide=map.get(this.lbl_place_where_provide);
           });
  }

}
